import {InitPage} from "../index";
import swal from "sweetalert";

class ConfirmDialog {
    constructor() {
        $('.userConfirm').on('click', this.confirmation);
    }

    confirmation(e) {
      const _this = this;
      e.preventDefault();
      const target = e.target;
      
      let confirmMessage = "";
      let confirmTitle   = "Are you sure?";
      if (typeof $(target).data("confirm-message") !== "undefined") {
          confirmMessage = $(target).data("confirm-message");
      }
      if (typeof $(target).data("confirm-title") !== "undefined") {
          confirmTitle = $(target).data("confirm-title");
      }

      swal({
        title: confirmTitle,
        text:  confirmMessage,
        icon: "warning",
        closeOnClickOutside: false,
        className: "sn-m-modal",
        buttons: {
          cancel: {
            text: "No",
            value: null,
            visible: true,
            className: "sn-btn sn-btn-sm sn-btn-silver",
            closeModal: true
          },
          confirm: {
            text: "Yes",
            value: true,
            visible: true,
            className: "sn-btn sn-btn-sm sn-btn-red",
            closeModal: true
          }
        },
        dangerMode: true,
      }).then((willConfirm) => {
        if (willConfirm) {
          $('.userConfirm').off('click');
          const event = e.originalEvent;
          target.dispatchEvent(event);
          $('.userConfirm').on('click', _this.confirmation);
        } else {
          return false;
        }
      });
      return false;
    }
}

export function LoadPage() {
    const confirm_dialog = new ConfirmDialog();
}

